module.exports = __webpack_public_path__ + "img/google_logo.776d8922.png";